import React, { useState } from "react";
import { Container, Form } from "react-bootstrap";
import { common } from "../js/common";

function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError("");
    setMessage("");
    setIsLoading(true);
    try {
      const response = await common.fetchRestAPI("password-reset", "POST", {
        email: email.trim(),
      });
      if (response.status === 429) {
        setError("Too many requests. Please wait a bit and try again.");
        return;
      }
      if (!response.ok) {
        const data = await response.json().catch(() => null);
        setError(data?.error || "Something went wrong. Please try again.");
        return;
      }
      setMessage(
        "If an account with that email exists, a reset link has been sent. Check your inbox (and spam folder).",
      );
    } catch {
      setError("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container className="vh-100 mx-auto p-4" style={{ maxWidth: "576px" }}>
      <div
        className="d-flex flex-column justify-content-center"
        style={{ height: "100%" }}
      >
        <a href="/login">&lt; Back to login</a>
        <h1 className="text-center p-3">Forgot Password</h1>
        <p className="text-muted">
          Enter the email on your account and we'll send you a link to choose a
          new password.
        </p>
        <Form onSubmit={handleSubmit}>
          <div className="mb-3">
            <input
              type="email"
              className="form-control"
              name="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              maxLength={255}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary" disabled={isLoading}>
            {isLoading ? "Sending..." : "Send reset link"}
          </button>
          <div className="p-2 mt-3">
            {message && (
              <div className="alert alert-success" role="alert">
                {message}
              </div>
            )}
            {error && (
              <div className="alert alert-danger alert-dismissible fade show" role="alert">
                {error}
                <button type="button" className="btn-close" onClick={() => setError("")} aria-label="Close"></button>
              </div>
            )}
          </div>
        </Form>
      </div>
    </Container>
  );
}

export default ForgotPasswordPage;
